import { createContext } from 'react'
import { Platform } from '../../../../types/global'

// @ts-ignore
export const PlatformsContext = createContext<Array<Platform>>()
